import { createFileRoute } from '@tanstack/react-router';
import { copilotStatus } from '@/api/resources';
import { warm } from '@/api/loaders';
import { requireSession } from '@/lib/route-guards';
import { DailyBriefingView } from '@/screens/daily-briefing';

// The Daily Briefing. The page itself is served for any session — when the
// copilot flag is off it renders the truthful absent state (and the nav
// section that links here disappears). The path stays `/brief`: it is the
// desktop landing route and bookmarked.
export const Route = createFileRoute('/brief')({
  beforeLoad: requireSession,
  loader: ({ context }) => warm(context.queryClient, copilotStatus(undefined)),
  component: Page,
});

function Page() {
  return <DailyBriefingView />;
}
